import clsx from 'clsx';
import { DaysOfWeek, DaysOfWeekOptions } from 'core/constants/days-of-week';

interface IDayOfTheWeekPicker {
  fieldProps: any;
}

const DayOfTheWeekPicker = ({ fieldProps }: IDayOfTheWeekPicker) => {
  return (
    <div className='flex space-x-3 mt-2'>
      {DaysOfWeekOptions.map((day) => (
        <div
          onClick={() => {
            let newValue: DaysOfWeek[] = [];
            if (fieldProps.value.includes(day.value)) {
              newValue = fieldProps.value.filter((d: DaysOfWeek) => d !== day.value);
            } else {
              newValue = [...fieldProps.value, day.value];
            }
            fieldProps.onChange(newValue);
          }}
          className={clsx(
            'w-9 h-9 flex justify-center items-center rounded-full cursor-pointer text-xs transition ease-in-out duration-200',
            fieldProps.value.includes(day.value) ? 'bg-primary text-white' : 'bg-gray-100 text-gray-400'
          )}
          key={day.value}
        >
          {day.label.slice(0, 2)}
        </div>
      ))}
    </div>
  );
};

export default DayOfTheWeekPicker;
